/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-operations-rotate': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M11.194 16.762l.218 1.25a8.062 8.062 0 002.65-.962l-.624-1.081a6.8 6.8 0 01-2.244.793zm4.068-2.343l.988.8a8.125 8.125 0 001.4-2.444l-1.169-.425a6.875 6.875 0 01-1.219 2.069zM5.938 17.03c.82.474 1.717.8 2.65.963l.22-1.25a6.8 6.8 0 01-2.245-.813l-.625 1.1zm-2.393-4.68l-1.169.425a8.125 8.125 0 001.375 2.444l.2-.163.763-.625a6.875 6.875 0 01-1.194-2.068l.025-.013zM18.125 10a8.031 8.031 0 00-.5-2.775l-1.169.425c.274.754.415 1.548.419 2.35h1.25zM16.25 4.781a8.125 8.125 0 00-12.5 0V2.5H2.5v5h5V6.25H4.256a6.875 6.875 0 0111.006-.669l.988-.8z"/>'
  }
})
